import {
  Button,
  ControlledAutocompleteSelect,
  ControlledInput,
  ControlledTextarea,
  Modal,
  ModalContent,
  ModalTitle
} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'
import {Controller} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {useAddStaticPartForm} from './hooks/useAddStaticPartModal'

import {useStaticPartsTypeOptions} from '@refra/modules/refra-static-parts/hooks/useStaticPartsTypeOptions'

export const AddStaticPartModal = () => {
  const {t} = useTranslation()
  const {equipmentTypeOptions} = useStaticPartsTypeOptions()

  const {
    formMethods: {control, formState, setValue},
    isFormBeingProcessed,
    onSubmit,
    onClose
  } = useAddStaticPartForm()

  return (
    <Modal open onClose={() => onClose()} data-cy="refra_add_static_part_modal">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className={'flex justify-between'}>
          <ModalTitle data-cy="refra_update_material_modal_title">
            {t('staticParts.addStaticPartModal.title')}
          </ModalTitle>
        </div>
        <ModalContent>
          <div className="flex flex-col gap-4">
            <Controller
              name="name"
              control={control}
              rules={{
                required: t('error.required')
              }}
              render={({field}) => (
                <ControlledInput
                  {...field}
                  label={t('staticParts.table.name')}
                  error={formState.errors.name?.message}
                  isTouched={!!formState.touchedFields.name}
                  isDisabled={isFormBeingProcessed}
                  data-cy="add_static_part_name_input"
                />
              )}
            />
            <Controller
              name="description"
              control={control}
              rules={{
                required: t('error.required')
              }}
              render={({field}) => (
                <ControlledTextarea
                  {...field}
                  label={t('staticParts.table.description')}
                  error={formState.errors.description?.message}
                  isTouched={!!formState.touchedFields.description}
                  isDisabled={isFormBeingProcessed}
                  data-cy="add_static_part_description_text_area"
                />
              )}
            />
            <Controller
              name="type"
              control={control}
              rules={{required: t('error.required')}}
              render={({field}) => (
                <div data-cy="add_static_part_type_select">
                  <ControlledAutocompleteSelect
                    label={t('staticParts.table.equipmentType')}
                    options={equipmentTypeOptions}
                    selectedValues={[field.value ?? '']}
                    error={formState.errors.type?.message}
                    isDisabled={isFormBeingProcessed}
                    isTouched={!!formState.errors.type?.message}
                    onChange={(type) => {
                      setValue('type', undefined)
                      field.onChange(type[0])
                    }}
                  />
                </div>
              )}
            />
          </div>
        </ModalContent>
        <div className={'space-x-2 flex justify-end'}>
          <Button
            disabled={isFormBeingProcessed}
            data-cy="cancel_static_part_btn"
            icon={mdiClose}
            onClick={() => onClose()}
            variant="secondary"
          >
            {t('common.cancel')}
          </Button>
          <Button type="submit" disabled={isFormBeingProcessed} data-cy="add_static_part_btn">
            {t('common.create')}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
